
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/campaigns",
      function () {
        return require("private-next-pages/content/campaigns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/campaigns"])
      });
    }
  